module.exports = __webpack_public_path__ + "static/media/Verification-graphics.3bebbab8.png";